"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFormsDataElementType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EFormsDataElementType_Factory = /** @class */ (function () {
    function EFormsDataElementType_Factory() {
    }
    EFormsDataElementType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    EFormsDataElementType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return EFormsDataElementType_Factory;
}());
exports.EFormsDataElementType_Factory = EFormsDataElementType_Factory;
